module.exports = __webpack_public_path__ + "static/media/exhibition.98687e99.png";